import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { loadContract } from "../../../../store/actions/user";

import Failure from "./Failure";

const mapDispatchToProps = { loadContract };

export default withRouter(connect(null, mapDispatchToProps)(Failure));
